(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["heyday-header-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('heyday-search-form')) {
    customElements.define('heyday-search-form', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const form = this.querySelector('form');
        form.addEventListener('formdata', event => {
          event.formData.set('q', this.queryFor(event.formData.get('q') || ''));
        }, { signal: this.events.signal });
        if (this.hasAttribute('data-search-results-page')) {
          const url = new URL(window.location.href);
          const original = url.searchParams.get('q');
          const query = this.queryFor(original || '');
          if (original && query !== original) {
            url.searchParams.set('q', query);
            url.searchParams.delete('page');
            window.location.replace(url);
          }
        }
      }
      queryFor(term) {
        switch (term.trim().toLowerCase()) {
          case 'geese': return '(title:geese OR title:goose)';
          case 'goose': return '(title:goose OR title:geese)';
          case 'teal': return 'title:teal';
          case 'pintail':
          case 'pintails': return 'title:pintail*';
          case 'woodduck':
          case 'woodducks':
          case 'wood duck':
          case 'wood ducks': return 'title:HydroFoam AND title:"wood ducks"';
          default: return term;
        }
      }
      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
      }
    });
  }
  if (!customElements.get('heyday-header-search')) {
    customElements.define('heyday-header-search', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('.heyday-search-results');
        this.status = this.querySelector('[data-search-status]');
        this.hint = this.querySelector('#HeydaySearchHint');
        this.revision = 0;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        document.querySelectorAll('[data-heyday-search-open]').forEach(trigger => {
          if (typeof this.dialog.showModal !== 'function') return;
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', this.dialog.id);
          trigger.addEventListener('click', event => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            if (this.dialog.open) return;
            this.trigger = trigger;
            this.previousOverflow = ['overflow-x', 'overflow-y'].map(name => ({ name, value: document.body.style.getPropertyValue(name), priority: document.body.style.getPropertyPriority(name) }));
            this.dialog.showModal();
            document.body.style.setProperty('overflow', 'hidden');
            this.input.focus({ preventScroll: true });
            if (this.input.value.trim()) this.queueSearch();
          }, options);
        });
        this.querySelector('[data-search-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          this.cancelSearch();
          this.restoreOverflow();
          const trigger = this.trigger?.getClientRects().length ? this.trigger : Array.from(document.querySelectorAll('[data-heyday-search-open]')).find(item => item.getClientRects().length);
          trigger?.focus({ preventScroll: true });
        }, options);
        this.input.addEventListener('input', event => { if (!event.isComposing) this.queueSearch(); }, options);
        this.input.addEventListener('compositionend', () => this.queueSearch(), options);
        this.input.addEventListener('keydown', event => {
          if (event.key !== 'ArrowDown') return;
          const first = this.results.querySelector('a');
          if (first) { event.preventDefault(); first.focus(); }
        }, options);
      }
      cancelSearch() {
        clearTimeout(this.timer);
        this.request?.abort();
        this.revision += 1;
        this.results.removeAttribute('aria-busy');
      }
      restoreOverflow() {
        if (!this.previousOverflow) return;
        document.body.style.removeProperty('overflow');
        this.previousOverflow.forEach(({ name, value, priority }) => {
          if (value) document.body.style.setProperty(name, value, priority);
          else document.body.style.removeProperty(name);
        });
        this.previousOverflow = null;
      }
      queueSearch() {
        this.cancelSearch();
        this.results.replaceChildren();
        const term = this.input.value.trim();
        this.status.textContent = '';
        this.hint.hidden = !!term;
        if (!term) return;
        this.status.textContent = this.dataset.loading;
        const revision = this.revision;
        this.timer = setTimeout(() => this.search(term, revision), 250);
      }
      async search(term, revision) {
        this.request = new AbortController();
        this.results.setAttribute('aria-busy', 'true');
        const url = new URL(this.dataset.endpoint, window.location.origin);
        url.searchParams.set('q', this.querySelector('heyday-search-form').queryFor(term));
        url.searchParams.set('section_id', 'heyday-predictive-search');
        url.searchParams.set('resources[type]', 'product,collection,article,page');
        url.searchParams.set('resources[limit]', '4');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        try {
          const response = await fetch(url, { signal: this.request.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Search request failed');
          const markup = await response.text();
          if (revision !== this.revision || !this.dialog.open) return;
          const content = new DOMParser().parseFromString(markup, 'text/html').querySelector('[data-heyday-predictive-content]');
          if (!content) throw new Error('Search response missing');
          this.results.replaceChildren(content);
          this.status.textContent = this.dataset.count.replace('[count]', content.dataset.resultCount);
        } catch (error) {
          if (error.name === 'AbortError' || revision !== this.revision) return;
          this.status.textContent = this.dataset.error;
        } finally {
          if (revision === this.revision) this.results.removeAttribute('aria-busy');
        }
      }
      disconnectedCallback() {
        this.cancelSearch();
        this.restoreOverflow();
        this.events?.abort();
        this.initialized = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('heyday-menu-accordions')) {
    customElements.define('heyday-menu-accordions', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.addEventListener('click', event => {
          const trigger = event.target.closest('[data-menu-accordion]');
          if (!trigger || !this.contains(trigger)) return;
          const panel = this.querySelector('#' + CSS.escape(trigger.getAttribute('aria-controls')));
          if (!panel) return;
          const expanded = trigger.getAttribute('aria-expanded') !== 'true';
          trigger.setAttribute('aria-expanded', String(expanded));
          trigger.classList.toggle('active', expanded);
          panel.inert = !expanded;
          panel.setAttribute('aria-hidden', String(!expanded));
          if (expanded) panel.style.maxHeight = panel.scrollHeight + 'px';
          else panel.style.removeProperty('max-height');
        }, { signal: this.events.signal });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
